import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { StatusSwitcherCell } from "@/molecules/StatusSwitcherCell"
import { CweCell } from "./CweCell"
import { GuidanceActionCell } from "./GuidanceActionCell"
import { GuidanceNameCell } from "./GuidanceNameCell"
import { IssuesImpacted } from "./IssuesImpacted"
import { ResourceCell } from "./ResourceCell"

import type { SastGuidanceAPI } from "@/api/useSettings.types"
import type { NumberConvertor } from "@/hooks/useNumberConvertor"
import type { TFunction } from "@/hooks/useTranslation"

export const getColumnsTable = (props: {
  updating: boolean
  abbreviateNumber: NumberConvertor["abbreviateNumber"]
  actions: React.MutableRefObject<{
    onDelete: (record: Pick<SastGuidanceAPI, "id" | "name">) => void
    onEdit: (record: Pick<SastGuidanceAPI, "id" | "name">) => void
    onChangeStatus: (
      enabled: boolean,
      record: Pick<SastGuidanceAPI, "id">
    ) => void
  }>
  t: TFunction
}): object[] => {
  return [
    {
      title: "Guidance Name",
      render: GuidanceNameCell,
      ...getDefaultColumnParams("name")
    },
    {
      title: "Scope",
      render: ResourceCell,
      ...getDefaultColumnParams("specificResources")
    },
    {
      title: "CWEs",
      width: 200,
      render: CweCell,
      ...getDefaultColumnParams("cweIdsMore")
    },
    {
      title: "Issues Impacted",
      width: 135,
      align: "center",
      render: IssuesImpacted(props),
      ...getDefaultColumnParams("impactedIssues")
    },
    {
      title: "Status",
      width: 80,
      align: "center",
      render: StatusSwitcherCell<Pick<SastGuidanceAPI, "id" | "enabled">>(
        props.updating,
        props.actions.current.onChangeStatus,
        false
      ),
      ...getDefaultColumnParams("enabled", undefined, { preventDefault: true })
    },
    {
      width: 40,
      render: GuidanceActionCell(props),
      ...getDefaultColumnParams("actions", undefined, { preventDefault: true })
    }
  ]
}
